
import React from 'react';
import { connect } from 'react-redux';
import { getLeagues } from '../../../../selectors/common';
import { feedSettings } from '../../../../selectors/feedSettings';

import FeedSettings from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetFeedSettingsRequest, aUpdateFeedStatus, aUpdateOddsStatus } from '../../../../reducers';
import { aClearFeedSettings } from '../../../../reducers/feedSettings';

const mapToProps = (state) => ({
  leagues: getLeagues(state),
  feedSettings: feedSettings(state),
});

const actionsToProps = (dispatch) => ({
  getFeedSettings: (payload) => dispatch(aGetFeedSettingsRequest(payload)),
  updateFeedStatus: (payload) => dispatch(aUpdateFeedStatus(payload)),
  updateOddsStatus: (payload) => dispatch(aUpdateOddsStatus(payload)),
  clearFeedSettings: (payload) => dispatch(aClearFeedSettings(payload)),
});

const SoccerFeedSettings = (props) => (

  <FeedSettings
    leagues={props.leagues}
    feedSettings={props.feedSettings}
    getFeedSettings={props.getFeedSettings}
    updateFeedStatus={props.updateFeedStatus}
    updateOddsStatus={props.updateOddsStatus}
    clearFeedSettings={props.clearFeedSettings}
    permissionToUpdate={PERMISSIONS.FEEDSETTINGS_FEEDPUSHER_UPDATE}
    permissionToInvalidateOdds={PERMISSIONS.FEEDSETTINGS_FEEDPUSHER_INVALIDATE_ODDS}
  />

);

export default connect(mapToProps, actionsToProps)(SoccerFeedSettings);

